import type { PropsWithChildren } from 'react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Typography from '../Typography/Typography'
import { useTable } from './Table'

function BulkActions({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  const [state] = useTable()
  const selected = state.rows.filter((row) => row.selected).length

  return (
    <div className="flex items-center py-px">
      <Typography component="p" variant="subtitle2">
        <FormattedMessage
          id="Ui.number_selected"
          values={{ number: selected }}
        />
      </Typography>
      <div className="ml-6 items-center flex space-x-3">{children}</div>
    </div>
  )
}

export default BulkActions
